import { render, staticRenderFns } from "./BoPackage.vue?vue&type=template&id=6d692b26&"
import script from "./BoPackage.vue?vue&type=script&lang=js&"
export * from "./BoPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports